/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseOptionalTermsResponse } from '../models/ApiResponseOptionalTermsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TermsControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 선택약관 목록 조회
   * @returns ApiResponseOptionalTermsResponse OK
   * @throws ApiError
   */
  public getOptionalTerms({
    termsKey,
  }: {
    /**
     * terms key
     */
    termsKey: string,
  }): CancelablePromise<ApiResponseOptionalTermsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/terms/optional',
      query: {
        'termsKey': termsKey,
      },
    });
  }
  /**
   * 선택약관 목록 조회
   * @returns ApiResponseOptionalTermsResponse OK
   * @throws ApiError
   */
  public getOptionalTerms1({
    termsKey,
  }: {
    /**
     * terms key
     */
    termsKey: string,
  }): CancelablePromise<ApiResponseOptionalTermsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/terms/optional/',
      query: {
        'termsKey': termsKey,
      },
    });
  }
}
